
import React from "react";
import { Link } from "react-router-dom";
import "../../../assets/css/FeaturedSection.css";

const commitments = [
  {
    number: "01",
    icon: "fa-solid fa-house-chimney",
    title: "Affordable and Inclusive Housing",
    description:
      "We are dedicated to providing accessible, safe, and affordable housing solutions that improve the living standards of Nigerians across all communities.",
  },
  {
    number: "02",
    icon: "fa-solid fa-city",
    title: "Sustainable Urban Development",
    description:
      "Through strategic planning and responsible policies, we promote well-organized cities, resilient infrastructure, and environmentally sustainable urban growth.",
  },
  {
    number: "03",
    icon: "fa-solid fa-road",
    title: "Efficient Infrastructure Delivery",
    description:
      "We drive the development and renewal of public infrastructure, ensuring modern facilities and improved urban services for long-term national progress.",
  },
  {
    number: "04",
    icon: "fa-solid fa-shield-halved",
    title: "Transparency and Public Trust",
    description:
      "We uphold accountability, professionalism, and integrity in every project and policy, ensuring effective service delivery and public confidence in our mission.",
  },
];

function FeaturedSection() {
  return (
    <section
      id="featured-services"
      className="featured-services section fs-section"
      aria-labelledby="fs-heading"
    >
      <div className="container">
        {/* SECTION HEADING */}
        <header className="fs-heading" data-aos="fade-up">
          <span className="fs-eyebrow">
            <span className="fs-eyebrow-line" />
            Our Values in Action
            <span className="fs-eyebrow-line" />
          </span>

          <h2 id="fs-heading">
            Our Commitment
            <span> to Excellence</span>
          </h2>

          {/* <p>
            Building a better future through inclusive housing, sustainable
            communities, quality infrastructure, and accountable public service.
          </p> */}
        </header>

        {/* COMMITMENT CARDS */}
        <div className="fs-grid">
          {commitments.map((item, index) => (
            <article
              className="fs-card"
              key={item.number}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="fs-card-top">
                <span className="fs-number">{item.number}</span>

                <span className="fs-icon" aria-hidden="true">
                  <i className={item.icon} />
                </span>
              </div>

              <div className="fs-card-content">
                <span className="fs-card-label">
                  Our Commitment
                </span>

                <h3>{item.title}</h3>

                <p>{item.description}</p>
              </div>

              <div className="fs-card-bottom">
                <span className="fs-card-rule" />

                <Link
                  to="/"
                  className="fs-card-link"
                  aria-label={`Learn more about ${item.title}`}
                >
                  <span>Our Mission</span>
                  <i className="fa-solid fa-arrow-right" aria-hidden="true" />
                </Link>
              </div>
            </article>
          ))}
        </div>

        {/* CLOSING MESSAGE */}
        <div className="fs-footer" data-aos="fade-up">
          <span className="fs-footer-icon" aria-hidden="true">
            <i className="fa-solid fa-landmark" />
          </span>

          <p>
            <strong>Our mission. Our responsibility.</strong>
            <span>
              Working together for sustainable development and a better
              quality of life for all Nigerians.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
}

export default React.memo(FeaturedSection);
